import { createMemo } from 'solid-js';
import { state } from '../state';
import { wordCount } from '../preview/pipeline';

export function StatusBar() {
  const wc = createMemo(() => wordCount(state.doc));
  const readMin = createMemo(() => Math.max(1, Math.round(wc() / 220)));
  return (
    <footer class="statusbar">
      <span>{wc()} words</span>
      <span>·</span>
      <span>~{readMin()} min read</span>
      <span class="spacer" />
      <span>template: {state.template}</span>
      <span>·</span>
      <span>mode: {state.mode}</span>
    </footer>
  );
}
